module.exports = __webpack_public_path__ + "img/landscape-4.96b227ea.jpg";